module.exports = __webpack_public_path__ + "img/活动简介.04c9139d.png";